function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from 'prop-types';
import React from 'react';
export function withSlot(Component) {
  const Wrapper = ({
    children,
    ...props
  }) => {
    const filtered = [].concat(children).reduce((acc, child) => {
      var _child$props;

      if ((_child$props = child.props) !== null && _child$props !== void 0 && _child$props.slot) {
        acc.slot[child.props.slot] = child;
      } else {
        acc.rest.push(child);
      }

      return acc;
    }, {
      rest: [],
      slot: {}
    });
    return /*#__PURE__*/React.createElement(Component, _extends({
      content: filtered.slot
    }, props), filtered.rest);
  };

  Wrapper.propTypes = {
    children: PropTypes.node
  };
  return Wrapper;
}